import {
  SET_DISP_TAB,
  SET_DISP_DATE,
  SET_INIT_MATCHING_STATE,
  SET_SELECT_SEQUENCE_ID,
  SET_JOB_LIST,
  SET_SELECT_JOB,
  SET_ERR_DISP_DATE,
  SET_ERR_MATCHING_FILE,
  SET_UPLOAD_MEMO,
  SET_CHAR_CODE,
  SET_DELIMITER,
  SET_ERR_UPLOAD_MEMO_FLG,
  SET_ERR_UPLOAD_MEMO_MSG,
} from '../actions/MatchingAction';
import { MATCHING_COMPANY_TAB, CHAR_CODE_MATCHING, DELIMITER_MATCHING } from '../../common/const';

const initState = {
  // 表示タブ
  dispTab: MATCHING_COMPANY_TAB.SETTING,
  // 表示年月日
  dispDate: null,
  // 選択シーケンスID
  selectSequenceId: null,
  // ジョブ一覧
  jobList: [],
  // 選択ジョブ
  selectJob: {},
  // アップロードメモ
  uploadMemo: null,
  // 文字コード
  charCode: CHAR_CODE_MATCHING.SJIS,
  // 区切り文字
  delimiter: DELIMITER_MATCHING.COMMA,
  // 年月日エラーフラグ
  errDispDate: false,
  // マッチングファイルエラーフラグ
  errMatchingFile: false,
  // アップロードメモエラーフラグ
  errUploadMemoFlg: false,
  // アップロードメモエラーメッセージ
  errUploadMemoMsg: null,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_DISP_TAB:
      return { ...state, dispTab: action.dispTab };
    case SET_DISP_DATE:
      return { ...state, dispDate: action.dispDate };
    case SET_SELECT_SEQUENCE_ID:
      return { ...state, selectSequenceId: action.selectSequenceId };
    case SET_JOB_LIST:
      return { ...state, jobList: action.jobList };
    case SET_SELECT_JOB:
      return { ...state, selectJob: action.selectJob };
    case SET_UPLOAD_MEMO:
      return { ...state, uploadMemo: action.uploadMemo };
    case SET_CHAR_CODE:
      return { ...state, charCode: action.charCode };
    case SET_DELIMITER:
      return { ...state, delimiter: action.delimiter };
    case SET_ERR_DISP_DATE:
      return { ...state, errDispDate: action.errDispDate };
    case SET_ERR_MATCHING_FILE:
      return { ...state, errMatchingFile: action.errMatchingFile };
    case SET_ERR_UPLOAD_MEMO_FLG:
      return { ...state, errUploadMemoFlg: action.errUploadMemoFlg };
    case SET_ERR_UPLOAD_MEMO_MSG:
      return { ...state, errUploadMemoMsg: action.errUploadMemoMsg };
    case SET_INIT_MATCHING_STATE:
      return { ...initState };
    default:
      return state;
  }
};
